import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feature" }
const _hoisted_2 = { class: "feature__title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Pro")
const _hoisted_4 = { class: "feature__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_badge = _resolveComponent("badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createVNode(_component_fa_icon, {
        class: "feature__icon",
        icon: _ctx.icon
      }, null, 8, ["icon"]),
      _renderSlot(_ctx.$slots, "title"),
      (_ctx.pro)
        ? (_openBlock(), _createBlock(_component_badge, { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_4, [
      _renderSlot(_ctx.$slots, "description")
    ])
  ]))
}